/* Runs deferred, so jQuery is present by then. */
Shopify.removeItem = async function(id,quantity){
    await $.ajax({
      method:'POST',
      url:'/cart/change.js',
      data:{ id:id, quantity:0 },
      dataType: 'json'})
    .done(function() {
      $(".qv-add-to-cart-response").addClass('error');
      $(".qv-add-to-cart-response").removeClass('success'); 
      $('.qv-add-to-cart-response .msg').delay(3000).fadeTo(1000, 0);
       $('.qv-add-to-cart-response .msg').removeAttr("style");
      $(".cart-count-bubble").load(" .cart-count-bubble > *");    		
      $("#cart_reload").load("#cart_reload .cart_content > *");
    });
  }
  
  document.addEventListener('DOMContentLoaded', function() {
  $("#cart-icon-bubble").click(function(event) {
    $("#loader").addClass('loader');                             
    setTimeout(function(){
      $("#loader").removeClass("loader");    
    },1000);   
  });
  });
